"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledGenderSwitch = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _formik = require("formik");

var _InputHeader = _interopRequireDefault(require("../InputHeader"));

var _styled = require("../styled");

var _types = require("./types");

var _GenderIcon = _interopRequireDefault(require("./components/GenderIcon"));

var getNextValue = function getNextValue(value) {
  switch (value) {
    case _types.GenderEnum.UNKNOWN:
      return _types.GenderEnum.MALE;

    case _types.GenderEnum.MALE:
      return _types.GenderEnum.FEMALE;

    case _types.GenderEnum.FEMALE:
      return _types.GenderEnum.UNKNOWN;

    default:
      return _types.GenderEnum.UNKNOWN;
  }
};

var GenderSwitch = function GenderSwitch(props) {
  var className = props.className,
      name = props.name,
      _props$header = props.header,
      header = _props$header === void 0 ? '' : _props$header,
      prependIcon = props.prependIcon;

  var _useField = (0, _formik.useField)(name),
      _useField2 = (0, _slicedToArray2["default"])(_useField, 1),
      field = _useField2[0];

  var _useFormikContext = (0, _formik.useFormikContext)(),
      setFieldValue = _useFormikContext.setFieldValue;

  var value = field.value,
      onChange = field.onChange;

  var clickHandler = function clickHandler() {
    var next = getNextValue(value);
    setFieldValue(name, next);
    onChange(next);
  };

  return /*#__PURE__*/_react["default"].createElement(_styled.StyledInputContainer, null, /*#__PURE__*/_react["default"].createElement(_InputHeader["default"], {
    text: header,
    prependIcon: prependIcon
  }), /*#__PURE__*/_react["default"].createElement(StyledGenderSwitch, {
    className: className,
    onClick: clickHandler
  }, /*#__PURE__*/_react["default"].createElement(_GenderIcon["default"], {
    type: field.value
  })));
};

var StyledGenderSwitch = _styledComponents["default"].div.withConfig({
  displayName: "GenderSwitch__StyledGenderSwitch",
  componentId: "sc-1on2xr2-0"
})(["", " ", " display:flex;align-items:center;justify-content:center;cursor:pointer;height:48px;width:42px;"], _styled.InputStyles.Base, _styled.InputStyles.Normal);

exports.StyledGenderSwitch = StyledGenderSwitch;
var _default = GenderSwitch;
exports["default"] = _default;